const moment = require('moment');
import * as React from 'react';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from 'source/app/services/Shared/IconWithText/IconWithText';
import { StyleClass } from '../../../../../Shared/Styles/CSS';
import DeepWorkKipsChart from '../DeepWorkKipsChart';

export function LoadMoreDataLink({ dwkc }: { dwkc: DeepWorkKipsChart }) {
	return (
		<IconWithText
			iconSuffix={EGlyphicon.download}
			whenClicked={() => LoadMoreDKWCData(dwkc)}
			displayAsBlock
			withClass={StyleClass(`dwkc_loadmoredatalink`, {
				color: `silver`,
				marginTop: `10px`
			})}
		>
			scroll to load more data
		</IconWithText>
	);
}

export function LoadMoreDKWCData(dwkc: DeepWorkKipsChart) {
	const newOldestDate = moment(dwkc.state.oldestDate)
		.subtract(30, 'days')
		.format('YYYY-MM-DD');
	dwkc.setState({ oldestDate: newOldestDate });
}
